import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const scrollInterval = window.setInterval(() => {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: 'auto' });
          window.clearInterval(scrollInterval);
        }
      }, 100);
      const stopTimer = window.setTimeout(() => window.clearInterval(scrollInterval), 3000);
      return () => {
        window.clearInterval(scrollInterval);
        window.clearTimeout(stopTimer);
      };
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
    return undefined;
  }, [hash, pathname]);

  return (
    <div className="min-h-screen bg-background text-text-primary">
      <a
        href="#main-content"
        className="fixed left-4 top-3 z-[100] -translate-y-20 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-on-primary transition-transform focus:translate-y-0"
      >
        Preskoči na sadržaj
      </a>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  );
}
